export default "__VITE_PUBLIC_ASSET__986d1df7__"